var React = require('react');

function Shape3Inline (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n"),React.createElement("rect",{"className":"st0","width":"669.6","height":"543.3","key":1}),React.createElement("g",{"key":2},React.createElement("polyline",{"className":"st1","points":"335.2,0.5 661.4,0.5 661.4,104.8 333.7,104.8 195.9,329.4 118.6,455.5 118.6,543.4 335.2,543.4 \t"}))]);
}

Shape3Inline.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 669.6 543.9","style":{"enableBackground":"new 0 0 669.6 543.9"},"xmlSpace":"preserve"};

module.exports = Shape3Inline;

Shape3Inline.default = Shape3Inline;
